<template>
    <div>
        <router-link
                :to="'/pos/edit/multi-account/'+row.id"
                class="btn btn-sm btn-clean btn-icon btn-icon-sm"
        >
            <div class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                <span class="tooltip-text">{{ $t('pos.details') }}</span>
                <i class="fa fa-eye"></i>
            </div>
        </router-link>
        <a v-if="
        status == posStatuses.ACTIVE ||
        status == posStatuses.PENDING ||
        status == posStatuses.CORRECTION ||
       (status == posStatuses.AGENCY_CHECK && $can('manage','pos'))"
                href="#" @click="deleteMultiAccount" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
            <span class="tooltip-text">  {{ $t('pos.delete_pos_merchant') }}</span>
            <i class="fa fa-trash"></i>
        </a>
        <a v-if="psp == 'NOVIN'" href="#" @click="registerPosMerchant" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
            <span class="tooltip-text">{{ $t('pos.register_pos_merchant') }}</span>
            <i class="fa fa-check"></i>
        </a>
    </div>
</template>

<script>
import Vue from 'vue'
import toastr from 'toastr'
import store from '@/store'
import { posService } from '@/common/api.service'
import {posStatuses} from '@/constants/PosStatus'
import {i18n} from '@/plugins/i18n'
export default Vue.extend({
    data(){
      return{
          posStatuses,
          psp : store.state.pos.psp,
          status : store.state.pos.request_details.status,
      }
    },
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        },
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-top-left",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    mounted() {
    },
    methods: {
        deleteMultiAccount() {
            posService.removeStakeholder(this.row.id).then(response => {
                store.commit('pos/setDatatableStatus', 'new_data')
                return this.toastr.success(i18n.t('pos.bank_account_deleted'))
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            })
        },
        registerPosMerchant() {
            let param = {
                'pos_merchant_id': this.row.pos_merchant_id
            }
            posService.addNewCustomer(param, store.state.pos.psp).then(response => {
                store.commit('pos/setDatatableStatus', 'new_data')
                return this.toastr.success(response.data.message)
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            })
        }
    }
})
</script>